// extracted by mini-css-extract-plugin
export default {"description":"style_description__gViH9","fade-in":"style_fade-in__824Gz","top":"style_top__0ezH5","image":"style_image__1ZDM6"};